import { UserService } from "@/services";
import { nanoid } from "nanoid";

function resetState() {
  return {
    listNotify: [],

    loadingListNotify: false,

    amount: 100,
    findstr: "",
    date_to: null,
    date_from: null,

    itemsPage: 0,
    totalItems: 0,
    currentPage: 1,

    watcher: undefined,
  };
}

export default {
  namespaced: true,

  state: resetState(),

  getters: {
    getListNotify(state) {
      state.watcher;
      const countStart = state.currentPage === 1 ? 0 : (state.currentPage - 1) * state.itemsPage;
      const countEnd = countStart + state.itemsPage;
      return state.listNotify.slice(countStart, countEnd);
    },
    getParam: (state) => (name) => {
      return state[name];
    },
    getLoadingListNotify(state) {
      return state.loadingListNotify;
    },
    totalPages: (state) => Math.ceil(state.totalItems / state.itemsPage),

    getCurrentPage: (state) => state.currentPage,
  },

  mutations: {
    SET_LIST_NOTIFY(state, { data, before }) {
      if (before) {
        state.listNotify.push(...data);
      } else {
        state.listNotify = data;
      }
    },

    CHANGE_READ_NOTIFY(state, id) {
      const index = state.listNotify.findIndex((item) => item.notify_id === id);
      state.listNotify[index].read = true;
      state.watcher = nanoid();
    },

    SET_FINDSTR(state, value) {
      state.findstr = value;
    },

    SET_DATE_TO(state, value) {
      state.date_to = value;
    },

    SET_DATE_FROM(state, value) {
      state.date_from = value;
    },
    SET_LOADING_LIST_NOTIFY(state, value) {
      state.loadingListNotify = value;
    },
    SET_ITEMS_PAGE(state, value) {
      state.itemsPage = value;
    },
    SET_TOTAL_ITEMS(state, { count, before }) {
      if (before) {
        state.totalItems = state.totalItems + count;
      } else {
        state.totalItems = count;
      }
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value;
    },
  },

  actions: {
    async getNotify({ commit, rootGetters, state, getters }, before) {
      try {
        commit("SET_LOADING_LIST_NOTIFY", true);
        const data = {
          user_id: rootGetters["User/getUserId"],
          orgId: rootGetters["Organizations/ActiveOne/getId"],
          amount: state.amount,
          before: before,
          findstr: getters.getParam("findstr"),
          date_to: getters.getParam("date_to"),
          date_from: getters.getParam("date_from"),
        };
        const response = await UserService.fetchNotify(data);
        commit("SET_LIST_NOTIFY", { data: response.data?.notifications, before });
        commit("SET_TOTAL_ITEMS", { count: response.data?.amount, before });
      } catch (e) {
        console.error(e);
      } finally {
        commit("SET_LOADING_LIST_NOTIFY", false);
      }
    },

    changeParam({ commit }, { name, value }) {
      switch (name) {
        case "findstr":
          commit("SET_FINDSTR", value);
          break;
        case "dateTo":
          commit("SET_DATE_TO", value);
          break;
        case "dateFrom":
          commit("SET_DATE_FROM", value);
          break;
      }
    },

    setItemsPage({ commit }, value) {
      commit("SET_ITEMS_PAGE", value);
    },
    setCurrentPage({ commit, state, dispatch }, value) {
      commit("SET_CURRENT_PAGE", value);

      if (value + 1 === Math.floor(state.totalItems / state.itemsPage)) {
        dispatch("getNotify", state.listNotify[state.listNotify.length - 1].notify_id);
      }
    },

    changeReadNotify({ commit }, id) {
      commit("CHANGE_READ_NOTIFY", id);
    },
  },
};
